import * as React from "react";
import MuiRegularButton, { MuiRegularButtonProps } from "components/MuiExtras/Button/MuiRegularButton";
import { useTranslation } from 'react-i18next';

const ButtonConfirmAndClose: React.FC<MuiRegularButtonProps> = (props) => {
    const { t } = useTranslation();
    return (
        <MuiRegularButton {...props}>
            <span>{t("Common.Buttons.ConfirmAndCloseText")}</span>
        </MuiRegularButton>
    );
};

ButtonConfirmAndClose.defaultProps = {
    color: "success"
};

export default ButtonConfirmAndClose;
